const updateFunc = (controlData) => {
  const sensitivity =
    controlData["sensitivity"] !== undefined ? controlData["sensitivity"] : 95;
  const prevalence =
    controlData["prevalence"] !== undefined ? controlData["prevalence"] : 10;

  const d = prevalence;
  const tp = sensitivity;
  const fn = 100 - sensitivity;
  const tpr = tp / 100;
  const fnr = fn / 100;
  const atp = tpr * d;
  const afn = fnr * d;

  const calculatedData = {};
  calculatedData.atp = Math.round(atp);
  calculatedData.afn = Math.round(afn);
  return calculatedData;
};

export default updateFunc;
